import React, { Component } from 'react';
import { Waypoint } from 'react-waypoint';
import Header from './components/header/Header';
import BottomNavigation from './components/bottom-navigation/BottomNavigation';
import FlatfyCopyright from './components/flatfy-copyright/FlatfyCopyright';
import HeroScreen from './components/hero-screen/HeroScreen';
import FollowUs from './components/follow-us/FollowUs';
import CooperationScreen from './components/cooperation-screen/CooperationScreen';
import PartnersScreen from './components/partners-screen/PartnersScreen';
import ContactsScreen from './components/contacts-screen/ContactsScreen';
import NavigationOverlay from './components/navigation-overlay/NavigationOverlay';
import { AnalyticsProvider } from '../shared/providers/AnalyticsProvider';
import { Helmet } from 'react-helmet';
import * as Sentry from '@sentry/browser';
import { SENTRY_DSN } from './config';

import ForJournalistsScreen from './components/for-journalists-screen/ForJournalistsScreen';
import ArticlesScreen from './components/articles-screen/ArticlesScreen';
import SentryErrorBoundary from './components/sentry-error-boundary/SentryErrorBoundary';

import './assets/fonts/Roboto/index.css';
import './index.scss';
import favicon from './assets/favicon.png';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({ dsn: SENTRY_DSN });
}

const FooterWaypoint = ({ onShow, onHide }) => <Waypoint onEnter={onShow} onLeave={onHide} />;

const ThemeWaypoint = ({ from, to, onChange }) => (
  <Waypoint
    topOffset={70}
    bottomOffset={70}
    onPositionChange={({ currentPosition, previousPosition }) => {
      const isInside = currentPosition === Waypoint.inside;
      const wasAbove = previousPosition === Waypoint.above;
      const isAbove = currentPosition === Waypoint.above;
      const wasInside = previousPosition === Waypoint.inside;
      const noPrevious = previousPosition === undefined;

      if ((isInside && wasAbove) || (isInside && noPrevious)) {
        onChange(from);
      }
      if (isAbove && wasInside) {
        onChange(to);
      }
    }}
  />
);

class App extends Component {
  state = {
    currentScreenTheme: 'dark',
    showNavigation: false,
    showFollowUs: true,
  };

  setTheme = (currentScreenTheme) => {
    this.setState({ currentScreenTheme });
  };

  hideFollowUs = () => {
    this.setState({
      showFollowUs: false,
    });
  };

  showFollowUs = () => {
    this.setState({
      showFollowUs: true,
    });
  };

  handleNavigationOpen = () => {
    this.setState({
      showNavigation: true,
    });
  };

  handleNavigationClose = () => {
    this.setState({
      showNavigation: false,
    });
  };

  handleLinkFollow = () => {
    this.setState({
      showNavigation: false,
    });
  };

  render() {
    const { currentScreenTheme, showNavigation, showFollowUs } = this.state;

    return (
      <SentryErrorBoundary>
        <AnalyticsProvider>
          <Helmet>
            <title>Flatfy - Worldwide Real Estate Search Engine</title>
            <meta
              name="description"
              content="Flatfy.com is a comfortable search engine for real estate. We incorporate ads from many different sources to ensure a customer with a wide range of relevant real estate content."
            />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1, shrink-to-fit=no, minimum-scale=1, maximum-scale=1"
            />

            <meta name="theme-color" content="#ff9800" />
            <link rel="shortcut icon" type="image/png" href={favicon} />
          </Helmet>
          <Header
            theme={showNavigation ? 'dark' : currentScreenTheme}
            isNavigationOpened={showNavigation}
            onNavigationOpen={this.handleNavigationOpen}
            onNavigationClose={this.handleNavigationClose}
          />
          <NavigationOverlay show={showNavigation} onLinkFollow={this.handleLinkFollow} />
          <HeroScreen />
          <ThemeWaypoint from="dark" to="light" onChange={this.setTheme} />
          <CooperationScreen id="cooperation" />
          <ThemeWaypoint from="light" to="dark" onChange={this.setTheme} />
          <ForJournalistsScreen id="for-journalists" />
          <ThemeWaypoint from="dark" to="light" onChange={this.setTheme} />
          <ArticlesScreen id="rticles-example" />
          <ThemeWaypoint from="light" to="dark" onChange={this.setTheme} />
          <PartnersScreen id="partnership" />
          <ThemeWaypoint from="dark" to="light" onChange={this.setTheme} />
          <ContactsScreen id="contacts" />
          {showFollowUs && <FollowUs />}
          <FooterWaypoint onShow={this.hideFollowUs} onHide={this.showFollowUs} />
          <BottomNavigation />
          <FlatfyCopyright />
        </AnalyticsProvider>
      </SentryErrorBoundary>
    );
  }
}

export default App;
